import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const PhoneFlip = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="PhoneFlip" {...props}>
    <path d="M18.3814 1C19.8218 1.00003 20.7747 2.46871 20.2281 3.76953L20.1705 3.89453L16.1177 12L20.1705 20.1055C20.8353 21.4353 19.8681 23 18.3814 23H8.67633C7.90984 22.9997 7.21531 22.5621 6.88141 21.8818L6.81989 21.7432L3.2193 12.7432C3.02864 12.2664 3.02864 11.7336 3.2193 11.2568L6.81989 2.25684L6.88141 2.11816C7.21531 1.43788 7.90984 1.00028 8.67633 1H18.3814ZM8.67633 21H18.3814L17.3814 19H7.87653L8.67633 21ZM7.07672 17H16.3814L14.3814 13H5.47711L7.07672 17ZM5.47711 11H14.3814L18.3814 3H8.67633L5.47711 11ZM14.9996 6H10.9996V4H14.9996V6Z" fill="#000" />
  </StyledIcon>
));

PhoneFlip.displayName = 'PhoneFlip';

export { PhoneFlip };
